module.exports = __webpack_public_path__ + "static/media/pappa-carrlo.be1b7f07.png";